import { debounce } from 'lodash';
import { Box, Button, Flex, useDisclosure } from '@chakra-ui/react';

import FilterList from './FilterList';
import { AddNewIcon } from '@assets/icons';
import SearchBar from '@components/searchBar';
import CreatePromotion from '../CreatePromotion';
import FilterButton from '@components/filterButton';
import ModalTemplate from '@components/modalTemplate';
import { excludeKeys, checkFilterActive, roleCheck } from '@helpers/utils';
import { initialState, useFilters } from '@pages/ConsumerPromotion/hooks/state/useFilters';

export default function Head() {
    const filters = useFilters();
    const modalWidth = '586px';

    const role = roleCheck();
    const isAdmin = role === 'Area Admin';

    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenModal, onOpen: onOpenModal, onClose: onCloseModal } = useDisclosure();

    const handleSearch = (e) => {
        filters.set({ searchParam: e.target.value });
    };

    const debounceSearch = debounce(handleSearch, 400);

    const hasFilters = excludeKeys(filters, ['searchParam', 'limit', 'sort', 'page']);
    const showIndicator = checkFilterActive(hasFilters, initialState);

    return (
        <Box>
            <Flex gap={'24px'}>
                <SearchBar placeholder={'Cari nama consumer promotion'} onChange={debounceSearch} />
                <FilterButton
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}
                    showIndicator={showIndicator}
                    label="Filter"
                />
                {isAdmin && (
                    <Button ml={'auto'} onClick={onOpenModal}>
                        <AddNewIcon size={24} /> Promotion Claim
                    </Button>
                )}
            </Flex>

            <FilterList isOpen={isOpen} onClose={onClose} />

            <ModalTemplate isOpen={isOpenModal} width={modalWidth} onClose={onCloseModal} isClosebyOverlayClick={false}>
                <CreatePromotion onClose={onCloseModal} />
            </ModalTemplate>
        </Box>
    );
}
